import { selectCountries } from "../../../../../components/appData.slice";
import { FormElement, FormId } from "../../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../../components/types";
import { provinces } from "../../../../../shared";
import {
  selectCountry,
  selectIsDefaultCountrySelected,
  selectIsNotDefaultCountrySelected,
} from "../../../../../store/HOC/genericUI.selectors";
import { postalCodeMask } from "../../../../../utilities/masks";
import {
  selectShouldDisplayCompany,
  selectUIData,
  selectVehicleOwnerAvailableCities,
  selectVehicleOwnerCompanyData,
} from "../vehicleOwner.selectors";
import {
  setAvailableCities,
  setUIField,
  setUIObjectField,
} from "../vehicleOwner.slice";

import { ComponentId } from "./enums";

export const form: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.VEHICLE_OWNER_COMPANY_DATA,
  selector: selectVehicleOwnerCompanyData,
  isVisible: selectShouldDisplayCompany,
  content: [
    {
      sections: [
        {
          title: "Dane firmy",
          id: "vehicle-owner-company-details-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.NAME,
              label: "Nazwa firmy",
              required: true,
              placeholder: "Podaj pełną nazwę firmy",
            },
          ],
        },
        {
          id: "vehicle-owner-company-details-2",
          wrapper: { xs: 6 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.REGON,
              label: "REGON",
            },
          ],
        },
        {
          id: "vehicle-owner-company-details-3",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.PHONE,
              country: selectCountry(selectUIData)("ownerCompanyphone"),
              id: ComponentId.PHONE,
              onChange: setUIObjectField,
              label: "Telefon",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.EMAIL,
              label: "Email",
              required: true,
              tooltip:
                "Jeśli nie poda Pan/Pani adresu email, korespondencja będzie wysyłana pocztą, a czas likwidacji może się wydłużyć. Nie wykorzystamy maila do wysyłania pism innych niż związane ze szkodą.",
            },
          ],
        },
        {
          title: "Adres firmy",
          id: "vehicle-owner-company-details-4",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.STREET,
              label: "Ulica",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.STREET_2,
              label: "Numer budynku / mieszkania",
              required: true,
            },
          ],
        },
        {
          id: "vehicle-owner-company-details-5",
          wrapper: { xs: 12 },
          components: [
            {
              isVisible: selectIsNotDefaultCountrySelected(selectUIData)(
                "ownerCompany[country]"
              ),
              type: FormElement.ZIP_CODE,
              mask: postalCodeMask,
              id: ComponentId.ZIP_CODE_PL,
              label: "Kod pocztowy",
              // LPPLWEBMOB-728
              onChange: setAvailableCities,
            },
            {
              isVisible: selectIsDefaultCountrySelected(selectUIData)(
                "ownerCompany[country]"
              ),
              type: FormElement.INPUT,
              id: ComponentId.ZIP_CODE_GENERIC,
              label: "Kod pocztowy",
            },
            // LPPLWEBMOB-728
            {
              isVisible: selectIsNotDefaultCountrySelected(selectUIData)(
                "ownerCompany[country]"
              ),
              type: FormElement.SELECT_CITY,
              id: ComponentId.CITY,
              label: "Miejscowość",
              items: [],
              selectAvailableCities: selectVehicleOwnerAvailableCities,
              required: true,
            },
            {
              isVisible: selectIsDefaultCountrySelected(selectUIData)(
                "ownerCompany[country]"
              ),
              type: FormElement.INPUT,
              id: ComponentId.CITY,
              label: "Miejscowość",
              required: true,
            },
          ],
        },
        {
          id: "vehicle-owner-company-details-6",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.AUTOCOMPLETE,
              id: ComponentId.COUNTRY,
              onChange: setUIField,
              items: selectCountries,
              required: true,
              label: "Kraj",
            },
            {
              type: FormElement.SELECT,
              id: ComponentId.PROVINCE,
              disabled: selectIsDefaultCountrySelected(selectUIData)(
                "ownerCompany[country]"
              ),
              label: "Województwo",
              items: [...provinces],
            },
          ],
        },
      ],
    },
  ],
};
